export const getLocalStorageObject = (key, log) => {
    var _a;
    let result = {};
    try {
        result = JSON.parse((_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : '{}');
    }
    catch (e) {
        log === null || log === void 0 ? void 0 : log.error('getLocalStorageObject', e);
    }
    return result;
};
export const setLocalStorageObject = (key, value, log) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    }
    catch (e) {
        log === null || log === void 0 ? void 0 : log.error('setLocalStorageObject', e);
    }
};
//# sourceMappingURL=safeLocalStorage.js.map